import axios from "axios";

const BASE_URL = "https://lms.childinfo.in/api/auth";

export const adminLogin = async (phone, password) => {
  return axios.post(`${BASE_URL}/admin_login.php`, { phone, password });
};

export const teacherLogin = async (phone, password) => {
  return axios.post(`${BASE_URL}/teacher_login.php`, { phone, password });
};

export const studentLogin = async (phone, password) => {
  return axios.post(`${BASE_URL}/student_login.php`, { phone, password });
};
